"use client";

import { FilterSelectMenu, type FilterMenuItem } from "../FilterSelectMenu";

interface Props {
  label: string;
  items: FilterMenuItem[];
  selectedId?: string;
  onSelect: (id: string) => void;
}

/**
 * Single-select menu (no checkboxes, no operator control) over the shared
 * FilterSelectMenu. Asset-specific status/preset menus supply `items`.
 */
export function SingleSelectFilterMenu({
  label,
  items,
  selectedId,
  onSelect,
}: Props) {
  return (
    <FilterSelectMenu
      label={label}
      selectedIds={selectedId ? [selectedId] : []}
      selectionMode="single"
      operator="any"
      availableOperators={[]}
      items={items}
      search=""
      showSearch={false}
      onToggle={(id) => onSelect(id)}
    />
  );
}
